import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { GroceryInput } from '@/models/grocery';

export const createGrocery = async ({
  name,
  phoneNumber,
  orderId,
  email,
  noGoGoFee,
  noGoGoFeeReason,
  doNotCharge,
  doNotChargeReason,
  applyDiscountedFee,
  applyDiscountedFeeReason,
  conditionalTip,
  notes,
  isConfirmedSameStoreActiveOrder,
}: GroceryInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateGrocery(
        $phoneNumber: String!
        $orderId: String!
        $email: String!
        $name: String
        $noGoGoFee: Boolean
        $noGoGoFeeReason: String
        $doNotCharge: Boolean
        $doNotChargeReason: String
        $applyDiscountedFee: Boolean
        $applyDiscountedFeeReason: String
        $conditionalTip: Boolean
        $notes: String
        $isConfirmedSameStoreActiveOrder: Boolean
      ) {
        createGrocery(
          phoneNumber: $phoneNumber
          orderId: $orderId
          email: $email
          name: $name
          noGoGoFee: $noGoGoFee
          noGoGoFeeReason: $noGoGoFeeReason
          doNotCharge: $doNotCharge
          doNotChargeReason: $doNotChargeReason
          applyDiscountedFee: $applyDiscountedFee
          applyDiscountedFeeReason: $applyDiscountedFeeReason
          conditionalTip: $conditionalTip
          notes: $notes
          isConfirmedSameStoreActiveOrder: $isConfirmedSameStoreActiveOrder
        ) {
          id
        }
      }
    `),
    variables: {
      name,
      phoneNumber,
      orderId,
      email,
      noGoGoFee,
      noGoGoFeeReason,
      doNotCharge,
      doNotChargeReason,
      applyDiscountedFee,
      applyDiscountedFeeReason,
      conditionalTip,
      notes,
      isConfirmedSameStoreActiveOrder,
    },
  });

  return !!response.data?.createGrocery;
};
